module.exports = __webpack_public_path__ + "img/shogi_2021_pack_2_0006.170272dd.png";